import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import { useIsMobileQuery } from 'src/hooks/useMediaQuery'
import { useGlobalContext } from 'src/stores/GlobalContext'
import { useToastAlert } from 'src/stores/ToastContext'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import UserImage from 'src/components/Elements/UserImage'
import ImageEditor from './ImageEditor'
import settingStyles from '../settingStyles.module.scss'
import Button from 'src/components/Elements/Button'
import IcomoonReact from 'icomoon-react'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'

const ImageUploader = () => {
  const { currentUser } = useGlobalContext()
  const { setAlert } = useToastAlert()
  const [image, setImage] = useState(currentUser?.photo)
  const [preview, setPreview] = useState(true)
  const isMobileSize = useIsMobileQuery()
  const fileInputRef = useRef(null)

  const handleFileUpload = () => {
    fileInputRef.current.click()
  }

  const handleNewImage = async (e) => {
    e.preventDefault()
    if (e.target.files[0]) {
      const fileType = e.target.files[0].type
      const validImageTypes = ['image/jpeg', 'image/png']
      if (validImageTypes.indexOf(fileType) < 0) {
        setAlert({
          status: 0,
          message: 'Profile image must be in .jpg, .jpeg, or .png format',
          title: 'Error',
          forceLogout: false
        })
        return false
      } else {
        setImage(e.target.files[0])
        setPreview(false)
      }
    }
  }

  return (
    <div
      className={classNames(
        generalStyles.flexColumn,
        generalStyles.alignVertical,
        generalStyles.mlNeg40
      )}
    >
      {preview
        ? <>
          <UserImage
            photoUrl={image}
            styles={classNames(settingStyles.previewImage, isMobileSize && settingStyles.previewImageMobile)}
            altText={`${currentUser?.first_name} ${currentUser?.last_name}`}
          />
          <div className={generalStyles.mt24}>
            <Button
              color={'lightBase'}
              type="file"
              onClick={handleFileUpload}
              size='small'
              label='Upload from photos'
              style={{ width: 178 }}
              iconRight={
                <IcomoonReact
                  iconSet={rebrandIconSet}
                  color={'white'}
                  size={12}
                  icon="Image"
                  style={{ marginBottom: 1 }}
                />
              }
            />
            <input
              id="file-upload"
              type="file"
              style={{ display: 'none' }}
              ref={fileInputRef}
              onChange={(e) => handleNewImage(e)}
            />
          </div>
        </>
        : <ImageEditor selectedImage={image} currentUserId={currentUser?.id} />
      }
    </div>
  )
}

export default ImageUploader
